module.exports = __webpack_public_path__ + "img/5_22.ca2af085.png";